<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const route = useRoute();

const { uiSettings, updateUISettings } = useUISettings();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'inbox_conversation',
    'conversation_through_inbox',
    'conversations_through_label',
    'team_conversations_through_label',
    'conversations_through_folders',
    'conversation_through_mentions',
    'conversation_through_unattended',
    'conversation_through_participating',
    'inbox_view_conversation',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});

// Rotas do fork onde o launcher do Capitão não deve aparecer (ex.: sobrepõe o
// botão "Próximo" do wizard do Disparador). Capitão não se aplica a essas telas.
const isHiddenRoute = computed(() => {
  const HIDDEN_ROUTES = [
    // Disparador
    'kanban_campaigns',
    'kanban_campaign_wizard',
    'kanban_campaign_detail',
    // Projetos
    'kanban_projects',
    'kanban_project_detail',
    // Atendimentos
    'kanban_appointments',
    // Flows
    'kanban_flows',
    'kanban_flow_execution_detail',
    'kanban_flow_history',
    'kanban_flow_builder',
    // Email Marketing
    'kanban_email',
    'kanban_email_wizard',
    'kanban_email_template_new',
    'kanban_email_template',
    'kanban_email_report',
    // Synapse (tem o próprio copiloto/Jarvis no canto)
    'synapse',
    // Chat Interno — o launcher fixo cobre o botão de enviar (pior no PWA)
    'kanban_internal_chats',
  ];
  return HIDDEN_ROUTES.includes(route.name);
});

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotLauncher = computed(() => {
  const isCaptainEnabled = isFeatureEnabledonAccount.value(
    currentAccountId.value,
    FEATURE_FLAGS.CAPTAIN
  );
  return (
    isCaptainEnabled &&
    !uiSettings.value.is_copilot_panel_open &&
    !isConversationRoute.value &&
    !isHiddenRoute.value
  );
});
const toggleSidebar = () => {
  updateUISettings({
    is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <div
    v-if="showCopilotLauncher"
    class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50"
  >
    <ButtonGroup
      class="rounded-full bg-n-alpha-2 backdrop-blur-lg p-1 shadow hover:shadow-md"
    >
      <Button
        icon="i-woot-captain"
        no-animation
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl transition-all duration-200 ease-out hover:brightness-110"
        lg
        @click="toggleSidebar"
      />
    </ButtonGroup>
  </div>
  <template v-else />
</template>
